import "esbuild-css-modules-plugin-ns-css:src/lib/gantt-task-react/src/components/task-item/bar/bar.module.css";

export default {
  "barBackground": "bar-module__barBackground_QCelXq__100",
  "barHandle": "bar-module__barHandle_QCelXq__100",
  "barWrapper": "bar-module__barWrapper_QCelXq__100"
};
      